import { Text } from '@chakra-ui/react';
import cn from 'classnames';
import Image from 'next/image';
import React from 'react';

import { assetsUri } from '@/services/api.service';
import { CarFilter } from '@/types/filters/filters.types';

import styles from './body-type-item.module.scss';

export const BodyTypeItem: React.FC<{
  bodyType: CarFilter;
  pageType?: string;
  selectFilter: (filterId: number) => void;
  isSelectedStyle?: boolean;
}> = ({ bodyType, selectFilter, isSelectedStyle }) => {
  const imageUri = `${assetsUri}/${bodyType.image}`;

  return bodyType.image ? (
    <div
      onClick={() => selectFilter(bodyType.id)}
      className={cn(styles.bodyTypeItem, {
        [styles.bodyTypeItemSelected as string]:
          isSelectedStyle ?? bodyType.isSelected,
        [styles.bodyTypeItemDisabled as string]: bodyType.isDisabled,
      })}
    >
      <Image
        className={styles.bodyTypeImage}
        src={imageUri}
        alt={bodyType.name}
        width={82}
        height={42}
      />
      <Text className={styles.bodyTypeText}>{bodyType.name}</Text>
    </div>
  ) : null;
};
